import React, { Component } from "react";
import logo2 from "../assets/logo2.png";

class SeminarWongwianyai2 extends Component {
  state = { registered: {} };
  seminar = "wongwianyai"; // unique seminar key for backend

  componentDidMount() {
    this.fetchRegistered();
    // Auto-refresh every 10s for all users to stay in sync
    this.interval = setInterval(this.fetchRegistered, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  // ✅ Fetch registration data from backend
  fetchRegistered = async () => {
    try {
      const res = await fetch(`/api/registered?seminar=${this.seminar}`);
      const data = await res.json();
      this.setState({ registered: data });
    } catch (err) {
      console.error("Error fetching registered list:", err);
    }
  };

  // ✅ Register or unregister participant
  handleRegister = async (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      // Unregister with admin PIN
      const pin = window.prompt("Enter PIN to unregister:");
      const res = await fetch("/api/unregister", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ seminar: this.seminar, id, pin }),
      });

      if (res.ok) {
        const data = await res.json();
        this.setState({ registered: data });
        alert("✅ Unregistered successfully.");
      } else {
        alert("❌ Incorrect PIN. Unregister cancelled.");
      }
    } else {
      // Register
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        const res = await fetch("/api/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ seminar: this.seminar, id }),
        });
        const data = await res.json();
        this.setState({ registered: data });
      }
    }
  };

  // ✅ Render each participant
  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue", // 🔴 Registered | 🔵 Available
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className="RosterTuesday1">
        <h3>Aikido Wong Wian Yai Dojo Participants Day 2</h3>
        <br />
        <br />

        {this.renderParticipant(1, "นายธงชัย ทิวาสิริกุล")}
        <br />
        {this.renderParticipant(2, "นายกานต์ ศรีสุวรรณ")}
        <br />
        {this.renderParticipant(3, "นายสุรเชษฐ์ ธารีพุฒ")}
        <br />
        {this.renderParticipant(4, "Mr.Ronbanchob Apiratikul")}
        <br />
        {this.renderParticipant(5, "Mr.Pongnart Sapsompong")}
        <br />

        <div>ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...</div>
        <br />
        <br />
        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarWongwianyai2;
